/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import React from "react";
import HomePanel from "../../components/home/homePanel";
import {withPrefix} from "gatsby";
import {Row, Column} from 'gatsby-theme-carbon';
import {ResourceCard} from 'gatsby-theme-carbon';
import "./home-cards.scss";
const MDXLayout = ({children, _frontmatter}) => React.createElement(React.Fragment, null, children);
function _createMdxContent(props) {
  return React.createElement(Row, {
    className: "resource-card-group homePanel homePanelRow"
  }, React.createElement(Column, {
    offsetLg: 4,
    colMd: 4,
    colLg: 4,
    colSm: 4,
    noGutterSm: true
  }, React.createElement(ResourceCard, {
    title: "Blog",
    href: "https://www.ibm.com/blog/category/accessibility/",
    target: "_blank",
    rel: "noopener noreferrer",
    aspectRatio: "2:1",
    actionIcon: "arrowRight"
  })), React.createElement(Column, {
    colMd: 4,
    colLg: 4,
    colSm: 4,
    noGutterSm: true
  }, React.createElement(ResourceCard, {
    title: "Events",
    href: "/events",
    aspectRatio: "2:1",
    actionIcon: "arrowRight"
  })), React.createElement(Column, {
    colMd: 4,
    colLg: 4,
    colSm: 4,
    offsetLg: 4,
    noGutterSm: true
  }, React.createElement(ResourceCard, {
    title: "Articles",
    href: "https://medium.com/design-ibm/tagged/accessibility",
    target: "_blank",
    rel: "noopener noreferrer",
    aspectRatio: "2:1",
    actionIcon: "arrowRight"
  })));
}
function MDXContent(props = {}) {
  return React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props));
}
export default MDXContent;
